<div class="jobs-timeline-dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      <mat-icon>work</mat-icon>
      <h2>{{ 'translations.global.label.jobsFor' | transloco: { name: data.userName } }}</h2>
    </div>
    <button mat-icon-button class="close-btn" (click)="close()" [attr.aria-label]="'translations.global.ariaLabels.close' | transloco">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="jobs-timeline">
    <div
      class="job-item"
      *ngFor="let job of sortedJobs; trackBy: trackByJobId"
      [class.job-item--active]="isJobActive(job)"
      [class.job-item--ended]="!isJobActive(job)"
    >
      <div class="job-item__indicator">
        <div class="job-item__dot"></div>
        <div class="job-item__line"></div>
      </div>
      <div class="job-item__content">
        <div class="job-item__header">
          <span class="job-item__title">{{ job.title }}</span>
          <span class="job-item__status">{{
            isJobActive(job) ? ('translations.global.label.active' | transloco) : ('translations.global.label.ended' | transloco)
          }}</span>
        </div>
        <div class="job-item__level">{{ job.level }}</div>
        <div class="job-item__dates">
          <mat-icon>calendar_today</mat-icon>
          <span>
            {{ job.startDate | date: 'mediumDate' }} -
            {{ job.endDate ? (job.endDate | date: 'mediumDate') : ('translations.global.label.present' | transloco) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="close()">{{ 'translations.global.button.close' | transloco }}</button>
  </div>
</div>
